/**
 * Google Analytics configuration
 */
export const GA_MEASUREMENT_ID = 'G-GFWKSHDE3H';

/**
 * Application URLs
 */
export const APP_URLS = {
  homepage: 'https://viewer.hellotwincat.dev/',
  title: 'TwinCAT Online Viewer'
};
